import React from "react";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: "#0A0A0A" }}>
      <div className="flex-1">
        <div className="border-b" style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}>
          <div className="max-w-4xl mx-auto px-6 py-4">
            <a href="/" className="text-xl font-semibold" style={{ color: "#3D6B4A" }}>
              NutriNori
            </a>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-6 py-16">
          <h1 className="text-4xl font-bold mb-8" style={{ color: "#FFFFFF" }}>
            Conditions d'utilisation
          </h1>
          
          <div className="space-y-6 text-base leading-relaxed" style={{ color: "rgba(255, 255, 255, 0.7)" }}>
            <p>
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                1. Acceptation des conditions
              </h2>
              <p>
                En accédant et en utilisant l'application NutriNori, vous acceptez d'être lié par ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser l'application.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                2. Description du service
              </h2>
              <p>
                NutriNori est une application de nutrition qui vous permet d'analyser vos repas, de suivre votre alimentation et de recevoir des recommandations nutritionnelles personnalisées.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                3. Compte utilisateur
              </h2>
              <p>
                Pour utiliser certaines fonctionnalités de l'application, vous devez créer un compte. Vous êtes responsable de maintenir la confidentialité de vos identifiants de connexion et de toutes les activités effectuées sous votre compte.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                4. Utilisation acceptable
              </h2>
              <p>
                Vous acceptez d'utiliser l'application uniquement à des fins légales et conformément à ces conditions. Vous ne devez pas :
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Utiliser l'application de manière abusive ou frauduleuse</li>
                <li>Tenter d'accéder à des parties non autorisées du système</li>
                <li>Transmettre des virus ou du code malveillant</li>
                <li>Violer les droits de propriété intellectuelle</li>
              </ul>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                5. Abonnement et paiements
              </h2>
              <p>
                Certaines fonctionnalités de NutriNori sont disponibles via un abonnement payant (NutriNori Pro). Les conditions de paiement et d'annulation sont gérées par l'App Store (iOS) ou Google Play (Android).
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                6. Avertissement médical
              </h2>
              <p className="font-semibold" style={{ color: "#FFFFFF" }}>
                Important : NutriNori est un outil d'information nutritionnelle et ne remplace pas l'avis d'un professionnel de santé.
              </p>
              <p className="mt-2">
                Les recommandations fournies par l'application sont à titre informatif uniquement. Consultez toujours un médecin ou un nutritionniste qualifié avant de modifier votre régime alimentaire, particulièrement si vous avez des problèmes de santé.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                7. Limitation de responsabilité
              </h2>
              <p>
                NutriNori fournit l'application "en l'état" sans garantie d'aucune sorte. Nous ne serons pas responsables des dommages directs, indirects, accessoires ou consécutifs résultant de l'utilisation de l'application.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                8. Modification des conditions
              </h2>
              <p>
                Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications entreront en vigueur dès leur publication dans l'application. Votre utilisation continue de l'application après ces modifications constitue votre acceptation des nouvelles conditions.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                9. Contact
              </h2>
              <p>
                Pour toute question concernant ces conditions d'utilisation, contactez-nous à :
              </p>
              <p className="mt-2">
                <a href="mailto:support@nutrinori.com" style={{ color: "#3D6B4A" }} className="hover:underline">
                  support@nutrinori.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer theme="dark" />
    </div>
  );
};

export default Terms;
